import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";

// Pages
import HomePage from "@/pages/HomePage";
import AboutPage from "@/pages/AboutPage";
import TeamPage from "@/pages/TeamPage";
import ServicesPage from "@/pages/ServicesPage";
import PricingPage from "@/pages/PricingPage";
import BlogPage from "@/pages/BlogPage";
import BlogPostPage from "@/pages/BlogPostPage";
import ContactPage from "@/pages/ContactPage";
import AppointmentPage from "@/pages/AppointmentPage";
import { PrivacyPolicyPage, CookiePolicyPage, TermsPage } from "@/pages/LegalPages";
import NotFoundPage from "@/pages/NotFoundPage";
import GtmTracker from "@/components/GtmTracker";

function App() {
  return (
    <div className="App" data-testid="app">
      <Toaster position="top-center" richColors />
      <BrowserRouter>
        <GtmTracker />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/za-nas" element={<AboutPage />} />
          <Route path="/ekip" element={<TeamPage />} />
          <Route path="/uslugi" element={<ServicesPage />} />
          <Route path="/ceni" element={<PricingPage />} />
          <Route path="/blog" element={<BlogPage />} />
          <Route path="/blog/:slug" element={<BlogPostPage />} />
          <Route path="/kontakti" element={<ContactPage />} />
          <Route path="/zapazi-chas" element={<AppointmentPage />} />
          <Route path="/politika-za-poveritelnost" element={<PrivacyPolicyPage />} />
          <Route path="/biskvitki" element={<CookiePolicyPage />} />
          <Route path="/obshti-usloviya" element={<TermsPage />} />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
